import React from "react";
import "./SectionHeading.css";
const Sectionheading = (props) => {
  return ( 
      <div className="heading-block  pt-5 pb-5">
        <h1>
          <span className="royalblue">{props.titleBefore}</span> {props.titleAfter}
        </h1>
        <p>
          {props.para}
        </p>
        <p><br/>{props.para2}</p>
        <p><b>{props.para3}</b></p>
      </div>
   
  );
};

export default Sectionheading;
